module.exports = __webpack_public_path__ + "media/recipes/53-9b9c7895.png";